import { DEFAULT_TAB_TITLE } from "@/constants/CConstants";

export const setPageTitle = (title?: string) => {
	document.title = DEFAULT_TAB_TITLE + (title ? `  |  ${title}` : "");
};
